import { BOOK_ALL } from "../data";

export const MobileBookBar = () => (
  <div data-testid="mobile-book-bar"
    className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-black/95 backdrop-blur-md border-t border-white/10 p-3">
    <a href={BOOK_ALL} data-testid="mobile-book-btn" className="btn-red w-full py-3.5 text-base">BOOK NOW →</a>
  </div>
);
